// @ts-strict-ignore
import { MIND_BOX } from '../api/mindBoxSDK'

/**
 * Checks if MindBox is initialized
 */
export const checkMindBoxCLI = (): boolean => {
	const isInitialized = !!window[MIND_BOX]

	if (!isInitialized) {
		console.warn(`MindBox is not initialized!`)
	}

	return isInitialized
}
